import React from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";

interface IProps {
    alt: string;
    src?: string;
    className?: string;
}

export const ResponsiveCardImgCover: React.FC<IProps> = ({alt, src, className}) => (
    <Image src={src} alt={alt} width="auto" height="auto" className={cx(cardBoxImageStyle, className)} />
);

const cardBoxImageStyle = css({
    height: "auto",
    width: "100%",
    "& img": {
        objectFit: "cover",
        width: "100%",
        height: "100%"
    },
    md: {
        height: "100%",
        width: "100%"
    }
});
import React from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";

interface IProps {
    alt: string;
    src?: string;
    className?: string;
}

export const ResponsiveCardImgCover: React.FC<IProps> = ({alt, src, className}) => (
    <Image src={src} alt={alt} width="auto" height="auto" className={cx(cardBoxImageStyle, className)} />
);

const cardBoxImageStyle = css({
    height: "auto",
    width: "100%",
    "& img": {
        objectFit: "cover",
        width: "100%",
        height: "100%"
    },
    md: {
        height: "100%",
        width: "100%"
    }
});
